import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';
import { providersLanding, resetPage } from '../../store/actions/pages';
import { getByName, reset } from '../../store/actions/search';
import ProvidersPageComponent from './ProvidersPage';
import { deleteProvider, download, updateEnableStatus, uploadFile } from '../../store/actions/contractProviders';
import { selectSelectedClientName } from '../../store/selectors/clients';
import { npiRolesLanding } from '../../store/actions/npiRoles';

export const ProvidersPage = connect(
    () => {

        const selectPending = createSelector(
            (state) => state.pages,
            (state) => state.search.getByName.pending,
            ( pages, searchPending) => {
                return pages['providers-landing'].pending || searchPending
            }
        );

        return (state: any, props) => ({
            pending: selectPending(state),
            selectedClientName: selectSelectedClientName(state as never),
            deletePending: state.contractProviders.delete.pending,
            uploadFilePending: state.contractProviders.delete.pending,
            updateStatusPending: state.contractProviders.updateStatus.pending
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            providersLanding: providersLanding,
            deleteProvider,
            searchGetByName: getByName,
            searchReset: reset,
            resetPagedTable: resetPage,
            downloadReport: download,
            uploadFile: uploadFile,
            updateEnableStatus: updateEnableStatus,
            npiRolesLanding: npiRolesLanding
        }, dispatch)
    })
)(injectIntl(ProvidersPageComponent));